import { CSSProperties } from "react";
import { Sizes } from "~/jsx/theme";
import { XCrossedSwordsSvg, XRomanOneSvg } from "./svg";

export const XBattleCardBack = ({
  level,
  style,
}: {
  level: number;
  style?: CSSProperties;
}) => {
  const { ratio, width, radius } = Sizes.battleCard;
  return (
    <div
      style={{
        borderRadius: radius,
        background: "linear-gradient(180deg, #280504 0%, #89342B 100%)",
        width,
        height: width * ratio,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 20,
        ...style,
      }}
    >
      <XCrossedSwordsSvg width={92} />
      <div style={{ display: "flex", gap: 4 }}>
        {[...new Array(level)].map((_, index) => (
          <XRomanOneSvg key={index} height={32} />
        ))}
      </div>
    </div>
  );
};
